import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import {Err} from '../../../err';
import {NotificationService} from '../../../services/notification.service';
import EMAIL_REGEX from '../../../validators/regex/email.regex';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit {

  form: FormGroup;
  user;
  post: any;
  email = '';
  activationKey: string;
  request = {
    email: ''
  };
  error = '';
  submitted = false;
  isLoading = false;
  message = '';

  constructor(private builder: FormBuilder,
    private usersService: UserService,
    private notificationService: NotificationService,
    private router: Router,
    public translate: TranslateService) {
    translate.use('nl');
    this.form = builder.group({
      'email': ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]],
    });
  }

  ngOnInit() { }

  get f() { return this.form.controls; }

  recover(post) {
    this.message = '';
    this.submitted = true;
    if (this.form.invalid || this.isLoading) {
      return;
    }
    this.email = post.email;
    this.request.email = this.email;
    this.isLoading = true;
    this.usersService.recover(this.request).subscribe(() => {
      this.isLoading = false;
      this.notificationService.success('er is een e-mail met meer informatie verzonden');
      this.router.navigate(['/login']);
    }, response => {
      this.isLoading = false;
      this.message = Err[response.error.message];
    });
  }

  reset() {
    this.request = {
      email: ''
    };
    this.form.reset();
  }

  clearMessage() {
    this.message = '';
  }
}
